import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  editMode: false,
  viewMode: false,
  deleteMode: false,
  approvalMode: false,
  menuIconVisibility: false,
  mode: {
    approvalFlag: false,
  },
};
const FilePaymentModeReducer = createSlice({
  name: "FilePaymentModes",
  initialState: initialState,
  reducers: {
    updateEditMode(state, action) {
      state.editMode = action.payload;
    },
    updateViewMode(state, action) {
      state.viewMode = action.payload;
    },
    updateDeleteMode(state, action) {
      state.deleteMode = action.payload;
    },
    updateApprovalMode(state, action) {
      state.approvalMode = action.payload;
    },
    updateMenuIconVisibility(state, action) {
      state.menuIconVisibility = action.payload;
    },
    updateApprovalFlag(state, action) {
      state.mode.approvalFlag = action.payload;
    },
  },
});
export const FilePaymentModeReducerAction = FilePaymentModeReducer.actions;
export default FilePaymentModeReducer.reducer;
